<template>
  <div
    class="flex-start flex-row items-center" 
    :id="element.Oid + '-element'"
    :style="{
      left: `${element.startPosition * 100}%`,
      opacity: `${opacity}`,
      transform: `scale(${element.startScale})`,
      marginBottom: `50px`,
      width:'100%',
      height:'100%',
      backgroundColor: element.backgroundColor,
    }"
  >
    
    <div class="ql-editor flex-column" :style="{ color: element.titleColor, textAlign: 'center', display: 'flex', justifyContent:'flex-start'}" >
    <img
      style="display: block"
      v-if="element.url"
      :src="element.url"
      class="h-12"
    />
      <span v-html = "element.text"  style="margin-top: 1%; width: 100%"> </span>
    </div>
  </div>
</template>

<script>
// import Component from "../component_location"

import { hexToRgb } from "@/utils.js";


export default {
  components: {},
  props: ["element", "mode"],

  data() {
    return {};
  },

  watch: {
    transformedText: function() {
      this.updateCSS();
    },
  },

  methods: {
     updateCSS() {
      var rgb = hexToRgb(this.element.backgroundColor);
      var backgroundOpacity;
      if (this.element.backgroundOpacity) {
        backgroundOpacity = this.element.backgroundOpacity;
      } else {
        backgroundOpacity = 0;
      }
      // UPDATE TEXT CSS SPECIFIC TO THIS ELEMENT...
      var id = this.element.Oid;
      $(".katex-html").css("color", this.element.equationColor);
      if (rgb == null) {
        return;
      }
      $("#" + id + "-element").css(
        "background",
        `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${backgroundOpacity})`
      );
    },
  },

  computed: {
    opacity() {
      return 1;
    },
    transformedText() {
      return this.element.text;
  },
  },

  mounted() {
    if ($(this).scrollTop() < 200 && $el.css('position') == 'fixed'){
    $('.fixedElement').css({'position': 'relative', 'top': '200px'});
}
  },
};
</script>

<style>
span > h1 {
  font-size: 32px;
}
span > h2 {
    font-size: 24px;
}
span > h3 {
  font-size: 18.72px;
}
span > h4 {
  font-size: 16px;
}
span > h5 {
  font-size: 13.28px;
}
span > h6 {
  font-size: 10.72px;
}
</style>
